import { StatFindDto, type StatFindInterface } from '@zaoblako/shared/modules/storage/dtos/stat/stat-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { StorageDtoKeyEnum } from '@zaoblako/shared/modules/storage/enums/storage-dto-key.enum';
import type { BucketFindInterface } from '@zaoblako/shared/modules/storage/dtos/bucket/bucket-find.dto';

import * as yup from 'yup';

/** S3 storage credentialis response body - DTO signature */
export interface StorageFindInterface {
  /** Unique ID. Cannot be changed */
  id: string;

  // Tech fields
  /** Storage creation date and time */
  created: Date;
  /** Storage last update date and time */
  updated: Date;

  // Data fields
  /** Human-readable name of the storage */
  name: string;
  /** If `true` then `https:` connection will be used instead of `http:` */
  secured?: boolean;
  /** Region system name */
  region: string;
  /** Storage endpoint address */
  endpoint: string;
  /** Storage access key */
  accessKey: string;
  /** Storage secret key */
  secretKey: string;

  // Relations
  /** Storage buckets */
  buckets?: BucketFindInterface[];
  /** Storage statistics */
  stat?: StatFindInterface;
}

/** S3 storage credentialis response body - DTO schema */
export const StorageFindDto = SerdeDtoClass.create<StorageFindInterface>(StorageDtoKeyEnum.STORAGE_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    hint: 'UUID',
    serializer: yup.string(),
  },
  created: {
    sortable: true,
    label: 'Создана',
    serializer: yup.date(),
  },
  updated: {
    sortable: true,
    label: 'Изменена',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  secured: {
    optional: true,
    label: 'Использовать защищенное соединение',
    serializer: yup.boolean(),
  },
  region: {
    optional: true,
    label: 'Регион',
    serializer: yup.string(),
  },
  endpoint: {
    sortable: true,
    label: 'Адрес',
    serializer: yup.string(),
  },
  accessKey: {
    label: 'Ключ доступа',
    serializer: yup.string(),
  },
  secretKey: {
    label: 'Секретный ключ',
    serializer: yup.string(),
  },
  buckets: {
    optional: true,
    label: '"Корзины" этого хранилища',
    nested: StorageDtoKeyEnum.BUCKET_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
  stat: {
    sortable: true,
    optional: true,
    nested: StatFindDto,
    label: 'Статистика по хранилищу',
    serializer: (_, nested) => nested,
  },
});
